<template>
  <div class="loading--page--container">

    <v-progress-circular
      v-if="loading"
      id="progress"
      :size="80"
      color="primary"
      indeterminate
    />

    <success-failure-display v-else-if="loadingError" :message="loadingErrorMessage" :hint="hint" error/>

    <div v-else
         :class="maxWidth ? 'maxwidth' : ''"
         class="loading--page">
      <slot/>
    </div>

  </div>
</template>
<script>
import SuccessFailureDisplay from "@/components/SuccessFailureDisplay";
import {CONNECTION_ERROR_MESSAGE, CONNECTION_ERROR_TEXT} from "../../helper/httpService";

export default {
  components: {
    SuccessFailureDisplay
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    loadingError: {
      type: Boolean,
      required: true
    },
    loadingErrorMessage: {
      type: String,
      required: true
    },
    maxWidth: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hint () {
      return this.loadingError && this.loadingErrorMessage === CONNECTION_ERROR_MESSAGE ? CONNECTION_ERROR_TEXT : null;
    }
  }
};
</script>
<style>
.loading--page--container {
  margin: 0 48px 100px 48px;
  display: flex;
  justify-content: center;
}

.loading--page--container #progress {
  top: 30vh;
}

.loading--page {
  flex: 1;
  font-size: 16px;
  max-width: 100%;
}

.loading--page.maxwidth {
  max-width: 768px;
  width: 100%;
}
</style>
